class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.menuItems = this.querySelectorAll('.mega-menu__link--level-2');

    this.menuItems.forEach((item) => {
      var timeout = null;
      
      item.addEventListener('mouseover', function() {
        document.querySelectorAll('.mega-menu__link--level-2').forEach((item) => {
          item.classList.remove('active');
        })
        
        timeout = setTimeout(() => {
          const subMenuTrigger = item.getAttribute('data-submenu-target');
          

          document.querySelectorAll('[data-submenu]').forEach((item) => {
            item.style.display = "none";
          });


          
          item.classList.add('active');
          document.querySelector('[data-submenu="' + subMenuTrigger + '"]').style.display = "block";
        }, 200);
      });

      item.addEventListener('mouseout', function() {
        clearTimeout(timeout);
      });
    });
  }
}
customElements.define('mega-menu', MegaMenu);
